<script setup lang="ts">
  import { provide, ref } from 'vue';
  import WarrantyForm from './views/WarrantyForm.vue';

  const breakpoint = ref(document.documentElement.getAttribute('breakpoint'));
  const breakpointObserver = new ResizeObserver(() => {
    if (
      document.documentElement.getAttribute('breakpoint') !== breakpoint.value
    ) {
      breakpoint.value = document.documentElement.getAttribute('breakpoint');
    }
  });
  breakpointObserver.observe(document.body);

  provide('breakpoint', breakpoint);
</script>

<template>
  <div class="patternlib-root" theme="hau">
    <div class="content__wrapper">
      <WarrantyForm></WarrantyForm>
    </div>
  </div>
</template>

<style>
.hau__free__guarantee__anker {
  text-decoration: underline;
}
</style>
